import React, { Component } from 'react';
import { view, list } from '../cruds/restApi';
import Edit from '../cruds/Edit';
import { notNull, stringNotBlank } from '../cruds/validators';
import InputText from '../components/input/InputText';
import RemoteInputSelect from '../components/input/RemoteInputSelect';
import Box from '../components/container/Box';
import RadioButtonGroup, { RadioButton } from '../components/input/RadioButtonGroup';
import './DepartmentCopyEdit.css';

class DepartmentCopyEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount = () => {
    const { entityId, entityName } = this.props;

    view(entityName, entityId)
      .then(data => {
        const { name, ...other } = data;
        this.setState({ initialResource: other }, this.fetchActivities);
      });

  };

  fetchActivities = () => {
    list('departmentActivities', { departmentId: this.state.initialResource.id })
      .then(data => this.setState({ activities: data }));
  };

  renderActivity = (activity, key) => (
    <div key={key} className="activities">
      <div>
        {activity.activityName}
        {this.renderSubstances(activity.substances)}
      </div>
    </div>
  );

  renderSubstances = (substances) => (
    <ul className="substances">
      {substances.map((s, i) =>
        <li key={i}>{s.substanceCode}</li>
      )}
    </ul>
  );

  renderAssociationList = () => {
    const { activities } = this.state;
    return (
      <div className="DepartmentCopyAssociationList">
        {activities ? activities.map((a, i) => this.renderActivity(a, i)) : ''}
      </div>
    );
  };

  render() {
    const { title, entityName, entityId, entityRoute, ...other } = this.props;
    const { initialResource } = this.state;
    const validators = [
      stringNotBlank('name', 'departments.err.name'),
      notNull('companyId', 'departments.err.companyId'),
      notNull('state', 'departments.err.state'),
    ];
    return (
      <div>
        {initialResource ? <Edit {...other}
              overrideTitle={title}
              entityName={[entityName, entityId, 'clone'].join('/')}
              entityRoute={entityRoute}
              initialValue={initialResource}
              validators={validators}
        >
          <InputText name="name" label="departmentsCopy.name" required />
          <InputText name="area" label="departmentsCopy.area" />
          <RemoteInputSelect from="companies"
                  optionValueName="id"
                  optionLabelName="name"
                  name="companyId"
                  label="departmentsCopy.companyId"
                  required
          />
          <InputText name="manager" label="departmentsCopy.manager" />
          <RadioButtonGroup name="state" label="departmentsCopy.state.name" required>
            <RadioButton value="ACTIVE" label="departmentsCopy.state.ACTIVE" />
            <RadioButton value="INACTIVE" label="departmentsCopy.state.INACTIVE" />
          </RadioButtonGroup>
          <InputText name="building" label="departmentsCopy.building" />
          <InputText name="labManager" label="departmentsCopy.labManager" />
          <InputText name="site" label="departmentsCopy.site" />
          <InputText name="dvrIt" label="departmentsCopy.dvrIt" />
          <InputText name="notes" label="departmentsCopy.notes" />
          <Box label="departmentsCopy.associationsMessage">
            {this.renderAssociationList()}
          </Box>
        </Edit> : ''}
      </div>
    );
  }
}

export default DepartmentCopyEdit;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentCopyEdit.js